import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CustomInput } from '../CustomInput';
import { ReactComponent as calendarIcon } from '../../assets/images/calendar.svg';
import { isWeekend } from 'date-fns';
import { Box, Tooltip } from '@mui/material';

export const CustomDatePicker = ({
  setFieldValue,
  name,
  value,
  offLastDate = true,
  onChange,
  disabled,
  dateStart,
  dateEnd,
  weekend = false,
  previousDate = false,
  tooltip,
  ...props
}) => {
  const localDateStart = new Date(dateStart);
  const disableDays = (date) => {
    return (dateStart ?
        new Date(localDateStart.getFullYear(), localDateStart.getMonth(), localDateStart.getDate()).valueOf() > date.valueOf() :
        new Date().valueOf() - 86400000 > date.valueOf()) ||
      (dateEnd ? dateEnd.valueOf() - 86400000 > date.valueOf() : new Date().valueOf() - 86400000 > date.valueOf()) ||
      (!weekend && isWeekend(date));
  }
  const handlerOnchange = (newValue) => {
    if (setFieldValue) {
      setFieldValue(name, newValue);
    } else {
      onChange(newValue);
    }
  };

  const shouldDisableDateValue = offLastDate ?
    disableDays :
    previousDate && !weekend ?
      isWeekend : dateStart ?
        date => new Date(localDateStart.getFullYear(), localDateStart.getMonth(), localDateStart.getDate()).valueOf() > date.valueOf()
        : () => {};

  const StyledDatePicker =
    <LocalizationProvider dateAdapter={AdapterDateFns} component="span">
      <DatePicker
        inputFormat="dd/MM/yyyy"
        shouldDisableDate={shouldDisableDateValue}
        value={value}
        onChange={handlerOnchange}
        disabled={disabled}
        components={{
          OpenPickerIcon: calendarIcon
        }}
        renderInput={(params) => {
          const {
            // eslint-disable-next-line no-unused-vars
            inputProps: { placeholder, ...inputProps },
            ...otherParams
          } = params;

          return <CustomInput {...props} {...inputProps} {...otherParams} error={props?.error} tooltip={null} />;
        }}
      />
    </LocalizationProvider>;

  return tooltip && disabled ?
    <Tooltip title={tooltip} arrow sx={{pointerEvents: 'auto'}}>
      <Box component="span" data-testid="Wrapper">{StyledDatePicker}</Box>
    </Tooltip> :
    StyledDatePicker;
};

CustomDatePicker.propTypes = {
  error: PropTypes.any,
  value: PropTypes.any,
  setFieldValue: PropTypes.func,
  name: PropTypes.string,
  offLastDate: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  dateStart: PropTypes.any,
  dateEnd: PropTypes.any,
  weekend: PropTypes.bool,
  previousDate: PropTypes.bool,
  tooltip: PropTypes.string,
};
